import { render, staticRenderFns } from "./UpdateInput.vue?vue&type=template&id=4baedbf5&scoped=true&"
import script from "./UpdateInput.vue?vue&type=script&lang=js&"
export * from "./UpdateInput.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInput.vue?vue&type=style&index=0&id=4baedbf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baedbf5",
  null
  
)

export default component.exports